import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TvIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tv"}/>
}
